'use client'
import {
  cornerConfig
} from "./chunk-ZHEFC5DU.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/ui/RoundedElement/RoundedElement.tsx
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var renderCorner = (variant) => {
  const { className, viewBox, path, width, height } = cornerConfig[variant];
  return /* @__PURE__ */ jsx("div", { className, children: /* @__PURE__ */ jsx(
    "svg",
    {
      width,
      height,
      viewBox,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("path", { d: path, fill: "currentColor" })
    }
  ) }, variant);
};
var RoundedElement = (_a) => {
  var _b = _a, {
    children,
    className = "",
    containerClassName = "",
    textClassName,
    variants = []
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "containerClassName",
    "textClassName",
    "variants"
  ]);
  return /* @__PURE__ */ jsx(
    "div",
    __spreadProps(__spreadValues({}, props), {
      className: twMerge("bg-body-level-1 rounded-L absolute w-fit", containerClassName),
      children: /* @__PURE__ */ jsxs("div", { className: twMerge("p-XXS relative", className), children: [
        /* @__PURE__ */ jsx("div", { className: textClassName || "text-body-level-1", children: variants.map((variant) => renderCorner(variant)) }),
        children
      ] })
    })
  );
};
var RoundedElement_default = RoundedElement;

export {
  RoundedElement_default
};
//# sourceMappingURL=chunk-A33G3ULA.mjs.map